<template>
  <SoDialog
    v-model="value"
    :card-title="title"
    :max-width="600"
    :data-testid="`${testId}-dialog`"
  >
    <p class="mb-4">{{ description }}</p>
    <ul class="ml-6 mb-6">
      <li v-for="point in bulletPoints" :key="point">{{ point }}</li>
    </ul>
    <div class="d-flex justify-end">
      <SoButton
        :data-testid="`${testId}-back-btn`"
        title="Back"
        type="secondary"
        large
        @click="value = false"
      />
      <SoButton
        class="ml-3"
        :data-testid="`${testId}-confirm-btn`"
        :title="confirmTitle"
        type="danger"
        :loading="loading"
        large
        @click="$emit('confirm')"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoButton,
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      bulletPoints: {
        type: Array as PropType<string[]>,
        required: true,
      },
      confirmTitle: {
        type: String,
        required: true,
      },
      testId: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "confirm"],
    computed: {
      value: {
        get(): boolean {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>
